var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"canvas-div",on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseDrag}},[_c('div',{ref:"canvas"})])])}
var staticRenderFns = []

export { render, staticRenderFns }